import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";
import { flatMap } from "lodash";

import { FormField } from "../../sharedComponents/formField";
import { required, isInt } from "../../constants/formValidators";
import FilterPanel, { PanelBody, PanelFooter } from "../../sharedComponents/filterPanel";
import DropZone from "../../sharedComponents/dropZoneWrap";
import { createTestimonialImage, getMemberTestimonialImages, editTestimonial } from "../../store/actions";

const AddImagesPanel = ({
	showAddImagePanel,
	toggleAddImagePanel,
	handleSubmit,
	createTestimonialImage,
	getMemberTestimonialImages,
	resetForm,
	setActiveTab,
	member,
	initialValues,
	editTestimonial,
	onReset
}) => {
	const notify = (msg) => {
		switch (msg.type) {
			case "error":
				return NotificationManager.error(msg.text, "", 5000);
			case "success":
				return NotificationManager.success(msg.text, "", 5000);
			default:
			// do nothing
		}
	};

	const typeList = [
		{ id: "A", name: "after" },
		{ id: "X", name: "unknown" },
		{ id: "B", name: "before" },
		{ id: "Z", name: "authorization" }
	];

	const [submitting, setSubmitting] = useState(false);
	const [dropZoneFiles, updateDropZoneFiles] = useState([]);

	useEffect(() => {
		dropZoneFiles && dropZoneFiles.length && setSubmitting(false);
	}, [dropZoneFiles]);
	const [resetDropZone, setResetDropZone] = useState(0);

	const addTestimonialImage = (values) => {
		setSubmitting(true);
		const dzFile = dropZoneFiles && dropZoneFiles.length ? dropZoneFiles[0].file : null;
		const formData = new FormData();
		dzFile && formData.append("photo_o", dzFile, dzFile.name);
		formData.append("type", values.type);
		formData.append("name", values.name);
		formData.append("weight", values.weight);
		formData.append("week", values.week);
		formData.append("primary", values.primary);
		formData.append("member", member);

		const successHandler = (event) => {
			setResetDropZone(resetDropZone + 1);
			resetForm("AddImagesForm");
			getMemberTestimonialImages(`member=${member}`);
			toggleAddImagePanel(false);
			setActiveTab(2);
		};

		const errorHandler = (event) => {
			event &&
				event.error_code === "VALIDATION_ERROR" &&
				NotificationManager.error(`${event.errors && flatMap(event.errors).toString()}`, "", 5000);
		};

		if (initialValues && initialValues.id) {
			editTestimonial(formData, initialValues.id, successHandler, errorHandler);
		} else {
			createTestimonialImage(formData, successHandler, errorHandler);
		}
	};

	return (
		<FilterPanel
			show={showAddImagePanel}
			className="hide-sub-header"
			toggle={(event) => {
				toggleAddImagePanel(event);
				setResetDropZone(resetDropZone + 1);
				resetForm("AddImagesForm");
				onReset();
			}}
			title={!initialValues || !initialValues.id ? " Add Images" : " Edit Details"}
			closeBtn>
			<form onSubmit={handleSubmit(addTestimonialImage)}>
				<PanelBody>
					{!initialValues ||
						(!initialValues.id && (
							<DropZone
								alert={notify}
								accepts={["jpeg", "jpg", "png", "gif", "bmp"]}
								className="mt-0"
								onAdd={(files) => {
									updateDropZoneFiles(files);
								}}
								forceReset={resetDropZone}
							/>
						))}
					<div className="row">
						<Field
							label="Title"
							name="name"
							type="text"
							validate={[required]}
							formGroupClass="col-12"
							component={FormField}
							onChange={() => setSubmitting(false)}
						/>
						<Field
							label="Type"
							name="type"
							type="select"
							formGroupClass="col-12"
							validate={[required]}
							options={typeList}
							component={FormField}
							onChange={() => setSubmitting(false)}
						/>
						<Field
							label="Weight"
							name="weight"
							type="number"
							validate={[required]}
							formGroupClass="col-12"
							component={FormField}
							min="0"
							onChange={() => setSubmitting(false)}
						/>
						<Field
							label="Week"
							name="week"
							type="number"
							validate={[required, isInt]}
							formGroupClass="col-12"
							component={FormField}
							min="0"
							onChange={() => setSubmitting(false)}
						/>
						<Field
							label="Primary"
							name="primary"
							type="checkbox"
							onChange={() => setSubmitting(false)}
							formGroupClass="col-12"
							component={FormField}
						/>
					</div>
				</PanelBody>
				<PanelFooter className="pt-0 pb-0">
					<div className="text-right w-100 py-3">
						<button
							type="button"
							className="btn btn-primary-dark btn-ghost mr-3"
							onClick={() => {
								toggleAddImagePanel(false);
								setResetDropZone(resetDropZone + 1);
								resetForm("AddImagesForm");
								onReset();
							}}>
							Cancel
						</button>
						<button disabled={submitting} type="submit" className="btn btn-primary-dark text-uppercase">
							Save
						</button>
					</div>
				</PanelFooter>
			</form>
		</FilterPanel>
	);
};

const mapDispatchToProps = { getMemberTestimonialImages, createTestimonialImage, resetForm: reset, editTestimonial };

export default reduxForm({
	form: "AddImagesForm",
	enableReinitialize: true
})(
	connect(
		null,
		mapDispatchToProps
	)(AddImagesPanel)
);
